import api from '@/api'

export default class RaffleApi {
	static async process(data) {
		return api.post('/raffle/process', data).then(function (response) {
			return response.data
		})
	}
}
